function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import Service from '@ember/service';
import { assert } from '@ember/debug';
export default class EmberLeafletService extends Service {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "components", []);
  }
  registerComponent(name, options = {}) {
    let as = options.as || name;
    assert(`Tried to register component \`${name}\` as \`${as}\`, but it was already registered. Try to register a different component or register it under a different name.`, this.components.find(c => c.name === name || c.as === as) === undefined);
    this.components.push({
      ...options,
      name,
      as
    });
  }
}